import React, { useMemo, useState, useEffect, useRef } from 'react';

function groupByN(n, data) {
  const result = [];
  for (let i = 0; i < data.length; i += n) result.push(data.slice(i, i + n));
  return result;
}
function getYearTable(year) {
  const nextTen = [];
  for (let i = year - 10; i < year + 10; i++) nextTen.push(i);
  return groupByN(5, nextTen);
}
function getTail(array) {
  const last = array[array.length - 1];
  return last[last.length - 1];
}

export default function YearsNavigation({ handleClick }) {
  const [year, setYear] = useState([]);
  const yearsList = useMemo(() => getYearTable(year), [year]);
  const [index, setIndex] = useState(0);
  const [tabkeyPressed, setTabkeyPressed] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const y = new Date().getFullYear();
    setYear(y + index * 10);
  }, [index]);

  function TopNav({ hideNav }) {
    return (
      <>
        <button
          className="fn-btn"
          onClick={() => {
            setIndex(index - 1);
            inputRef.current.focus();
          }}
          type="button"
          onKeyDown={() => setTabkeyPressed(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor" />
            <script xmlns="" />
          </svg>
        </button>
        {hideNav ? null : <div className="calendar-header-text">{`${yearsList[0][0]} to ${getTail(yearsList)}`}</div>}
        <button
          className="fn-btn"
          onClick={() => {
            setIndex(index + 1);
            inputRef.current.focus();
          }}
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="currentColor" />
            <script xmlns="" />
          </svg>
        </button>
      </>
    );
  }

  return (
    <div>
      <div className="calendar-header">
        <TopNav />
      </div>
      <input className="sr-only" type="text" name="hidden" onKeyDown={() => setTabkeyPressed(true)} ref={inputRef} />
      <table>
        <tbody>
          {yearsList.map(years => (
            <tr key={years}>
              {years.map(y => (
                <td key={y}>
                  <button className="fn-btn" type="button" onClick={() => handleClick(y)}>
                    {y}
                  </button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pt-5 pb-2 pl-2 d-flex justify-content-end">{tabkeyPressed && <TopNav hideNav />}</div>
    </div>
  );
}
